import {Injectable} from '@angular/core';
import {CommonService} from "../../../shared/services/common.service";
import {Observable} from "rxjs";
import {
  FetchContractDetailsModel
} from "../models/fetch-contract-details.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {
  UpdateContractDetailsModel
} from "../models/update-contract-details.model";

@Injectable({
  providedIn: 'root',
})

export class ContractsService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchContractDetails(payload: FetchContractDetailsModel['request']): Observable<FetchContractDetailsModel['response']> {
    const urlConfig = v1URL.contracts.fetch
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  updateContractDetails(payload: UpdateContractDetailsModel['request']): Observable<UpdateContractDetailsModel['response']> {
    const urlConfig = v1URL.contracts.update
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload), payload);
  }


}
